// GENERATED FILE - do not hand-edit the coordinates.
// Regenerate with tools/build-pincodes.py, or correct a pincode by putting a
// real measured road distance into VERIFIED_KM in pincodes.js instead.
//
// Delhi NCR pincode coordinates, derived from the India Post All-India Pincode
// Directory, which gives a latitude/longitude for every individual post office.
//
// How each row was produced:
//   1. Collect every post office carrying that pincode.
//   2. Drop offices more than 2.5x the median distance from the cluster centre.
//      India Post's file contains genuine errors - one "Rohtak" office is tagged
//      with coordinates in Greater Noida, 90 km away.
//   3. Take the medoid of what survives. A medoid, not an average, so a single
//      bad row cannot drag the answer off.
//   4. Relocate any pincode sitting more than 20 km from the centre of its own
//      4-digit peer group, and mark it low confidence.
//
// Row format: [lat, lng, city, state, confidence]
//
//   confidence   evidence                                        assumed error
//     'H'        3+ offices, tight cluster                        ~1 km
//     'M'        1-2 offices, or a slightly loose cluster         ~2.5 km
//     'L'        coordinate shared with another pincode, or       ~5 km
//                moved by the peer check. Verify these first.
//
// The engine widens the distance for 'M' and 'L' rows, so a coordinate that is
// short cannot price a trip below what it costs to make. Put a measured road
// distance in VERIFIED_KM and the estimate, the tier and the widening all stop
// applying to that pincode.

export const NCR_PINCODES = {
  // ---- Baghpat ----
  '250101': [29.13761, 77.26958, 'Baghpat', 'Uttar Pradesh', 'L'],  // 13 office(s), spread 9.7 km
  '250345': [29.06, 77.38, 'Baghpat', 'Uttar Pradesh', 'L'],  // 13 office(s), spread 9.7 km
  '250601': [28.98, 77.29, 'Baghpat', 'Uttar Pradesh', 'M'],  // 9 office(s), spread 5.1 km
  '250606': [29.02366, 77.3812, 'Baghpat', 'Uttar Pradesh', 'M'],  // 9 office(s), spread 6.7 km
  '250609': [28.94, 77.22, 'Baghpat', 'Uttar Pradesh', 'M'],  // 6 office(s), spread 5.0 km
  '250611': [29.10061, 77.26269, 'Baghpat', 'Uttar Pradesh', 'L'],  // 27 office(s), spread 10.0 km
  '250615': [29.13761, 77.26958, 'Baghpat', 'Uttar Pradesh', 'L'],  // 7 office(s), spread 7.0 km
  '250619': [29.0451, 77.18598, 'Baghpat', 'Uttar Pradesh', 'L'],  // 4 office(s), spread 11.0 km
  '250620': [29.15965, 77.3231, 'Baghpat', 'Uttar Pradesh', 'H'],
  '250621': [29.13761, 77.26958, 'Baghpat', 'Uttar Pradesh', 'L'],  // 4 office(s), spread 3.1 km

  // ---- Bahadurgarh ----
  '124102': [28.75997, 76.93176, 'Bahadurgarh', 'Haryana', 'H'],
  '124103': [28.64115, 76.63925, 'Bahadurgarh', 'Haryana', 'L'],  // 19 office(s), spread 12.9 km
  '124104': [28.68118, 76.74809, 'Bahadurgarh', 'Haryana', 'L'],  // 10 office(s), spread 24.0 km
  '124105': [28.59716, 76.78362, 'Bahadurgarh', 'Haryana', 'H'],
  '124107': [28.63499, 76.82396, 'Bahadurgarh', 'Haryana', 'M'],  // 2 office(s), spread 0.0 km
  '124109': [28.51016, 76.57934, 'Bahadurgarh', 'Haryana', 'M'],  // 11 office(s), spread 5.3 km
  '124141': [28.67159, 76.74809, 'Bahadurgarh', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '124142': [28.67159, 76.74809, 'Bahadurgarh', 'Haryana', 'L'],  // 3 office(s), spread 2.3 km
  '124146': [28.67159, 76.74809, 'Bahadurgarh', 'Haryana', 'L'],  // 5 office(s), spread 0.0 km
  '124201': [28.72537, 76.56269, 'Bahadurgarh', 'Haryana', 'L'],  // 4 office(s), spread 3.8 km
  '124202': [28.67159, 76.74809, 'Bahadurgarh', 'Haryana', 'L'],  // 3 office(s), spread 16.0 km
  '124504': [28.65533, 76.75341, 'Bahadurgarh', 'Haryana', 'M'],  // 2 office(s), spread 1.9 km
  '124505': [28.78116, 76.86481, 'Bahadurgarh', 'Haryana', 'H'],
  '124506': [28.68118, 76.9027, 'Bahadurgarh', 'Haryana', 'L'],  // 2 office(s), spread 6.1 km
  '124507': [28.68118, 76.9027, 'Bahadurgarh', 'Haryana', 'L'],  // 4 office(s), spread 2.6 km
  '124508': [28.6719, 76.8726, 'Bahadurgarh', 'Haryana', 'L'],  // 11 office(s), spread 9.2 km

  // ---- Central Delhi ----
  '110002': [28.63178, 77.24025, 'Central Delhi', 'Delhi', 'H'],
  '110005': [28.65356, 77.19183, 'Central Delhi', 'Delhi', 'H'],
  '110054': [28.70328, 77.22286, 'Central Delhi', 'Delhi', 'H'],
  '110055': [28.64608, 77.20253, 'Central Delhi', 'Delhi', 'H'],
  '110060': [28.63672, 77.18311, 'Central Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110084': [28.75722, 77.19778, 'Central Delhi', 'Delhi', 'H'],

  // ---- East Delhi ----
  '110051': [28.64536, 77.28711, 'East Delhi', 'Delhi', 'H'],
  '110091': [28.607, 77.29458, 'East Delhi', 'Delhi', 'H'],
  '110092': [28.66178, 77.30597, 'East Delhi', 'Delhi', 'H'],
  '110096': [28.61777, 77.32961, 'East Delhi', 'Delhi', 'H'],

  // ---- Faridabad ----
  '121001': [28.39178, 77.30214, 'Faridabad', 'Haryana', 'L'],  // 3 office(s), spread 1.5 km
  '121002': [28.40807, 77.32238, 'Faridabad', 'Haryana', 'M'],  // 5 office(s), spread 5.1 km
  '121003': [28.45136, 77.30794, 'Faridabad', 'Haryana', 'M'],  // 4 office(s), spread 6.7 km
  '121004': [28.33817, 77.32292, 'Faridabad', 'Haryana', 'L'],  // 13 office(s), spread 13.5 km
  '121005': [28.39178, 77.30214, 'Faridabad', 'Haryana', 'L'],  // 2 office(s), spread 2.9 km
  '121006': [28.36625, 77.31547, 'Faridabad', 'Haryana', 'H'],
  '121007': [28.38328, 77.32589, 'Faridabad', 'Haryana', 'L'],  // 3 office(s), spread 1.7 km
  '121008': [28.39178, 77.30214, 'Faridabad', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '121009': [28.48811, 77.29458, 'Faridabad', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '121010': [28.38328, 77.32589, 'Faridabad', 'Haryana', 'L'],  // 2 office(s), spread 68.1 km
  '121012': [28.39178, 77.30214, 'Faridabad', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '121013': [28.39178, 77.30214, 'Faridabad', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '121014': [28.4726, 77.4848, 'Faridabad', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '121015': [28.3453, 77.2965, 'Faridabad', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '121101': [28.3799, 77.43577, 'Faridabad', 'Haryana', 'H'],

  // ---- Ghaziabad ----
  '201001': [28.66831, 77.42983, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 1.7 km
  '201002': [28.67417, 77.44708, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 9 office(s), spread 4.4 km
  '201003': [28.72787, 77.40493, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 7 office(s), spread 5.8 km
  '201004': [28.69206, 77.45033, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201005': [28.6933, 77.35757, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 1.8 km
  '201006': [28.70062, 77.32885, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 2.6 km
  '201007': [28.67839, 77.37474, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201009': [28.65837, 77.42627, 'Ghaziabad', 'Uttar Pradesh', 'H'],
  '201010': [28.63997, 77.32975, 'Ghaziabad', 'Uttar Pradesh', 'H'],
  '201011': [28.66492, 77.33029, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201012': [28.65328, 77.35669, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201013': [28.68552, 77.48419, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201014': [28.63911, 77.37147, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201015': [28.68075, 77.52181, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 8 office(s), spread 8.6 km
  '201016': [28.62565, 77.43508, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201017': [28.68916, 77.44517, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201018': [28.65268, 77.43562, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201019': [28.66811, 77.42847, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 1 office(s), spread 0.0 km
  '201020': [28.61964, 77.34621, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201021': [28.63408, 77.34536, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201102': [28.76856, 77.32898, 'Ghaziabad', 'Uttar Pradesh', 'M'],  // 6 office(s), spread 6.2 km
  '201103': [28.67417, 77.44708, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 2 office(s), spread 3.9 km
  '201201': [28.67417, 77.44708, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 6 office(s), spread 7.5 km
  '201204': [28.83, 77.57, 'Ghaziabad', 'Uttar Pradesh', 'H'],
  '201206': [28.77038, 77.49887, 'Ghaziabad', 'Uttar Pradesh', 'L'],  // 19 office(s), spread 12.3 km

  // ---- Gurugram ----
  '122001': [28.46108, 77.02147, 'Gurugram', 'Haryana', 'L'],  // 9 office(s), spread 1.6 km
  '122002': [28.46609, 77.10583, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122003': [28.4465, 77.07362, 'Gurugram', 'Haryana', 'H'],
  '122004': [28.41389, 76.99319, 'Gurugram', 'Haryana', 'L'],  // 6 office(s), spread 0.1 km
  '122005': [28.50561, 77.07106, 'Gurugram', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122006': [28.48556, 77.00906, 'Gurugram', 'Haryana', 'H'],
  '122007': [28.462, 77.03164, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122008': [28.462, 77.03164, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122009': [28.46108, 77.02147, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122010': [28.46609, 77.10583, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122011': [28.462, 77.03164, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122012': [28.41389, 76.99319, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122015': [28.49736, 77.06306, 'Gurugram', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122016': [28.49658, 77.08528, 'Gurugram', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122017': [28.462, 77.03164, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122018': [28.462, 77.03164, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122051': [28.342, 76.93653, 'Gurugram', 'Haryana', 'M'],  // 2 office(s), spread 0.8 km
  '122052': [28.342, 76.93647, 'Gurugram', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122098': [28.39138, 77.05119, 'Gurugram', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '122101': [28.39138, 77.05119, 'Gurugram', 'Haryana', 'L'],  // 5 office(s), spread 0.4 km
  '122102': [28.35217, 77.06471, 'Gurugram', 'Haryana', 'H'],
  '122103': [28.24846, 77.0658, 'Gurugram', 'Haryana', 'H'],
  '122413': [28.41389, 76.99319, 'Gurugram', 'Haryana', 'L'],  // 7 office(s), spread 0.0 km
  '122414': [28.41389, 76.99319, 'Gurugram', 'Haryana', 'L'],  // 5 office(s), spread 0.0 km
  '122503': [28.32573, 76.77781, 'Gurugram', 'Haryana', 'H'],
  '122504': [28.46701, 77.0812, 'Gurugram', 'Haryana', 'H'],
  '122505': [28.42159, 76.91426, 'Gurugram', 'Haryana', 'L'],  // 6 office(s), spread 2.8 km
  '122506': [28.4468, 76.82569, 'Gurugram', 'Haryana', 'H'],

  // ---- Hapur ----
  '245101': [28.73058, 77.77588, 'Hapur', 'Uttar Pradesh', 'L'],  // 21 office(s), spread 9.6 km
  '245201': [28.7238, 77.84959, 'Hapur', 'Uttar Pradesh', 'L'],  // 11 office(s), spread 8.0 km
  '245301': [28.63243, 77.65075, 'Hapur', 'Uttar Pradesh', 'L'],  // 6 office(s), spread 8.6 km
  '245304': [28.71492, 77.65458, 'Hapur', 'Uttar Pradesh', 'L'],  // 15 office(s), spread 12.0 km

  // ---- Meerut ----
  '245206': [28.8351, 77.74138, 'Meerut', 'Uttar Pradesh', 'L'],  // 14 office(s), spread 8.3 km
  '250001': [29.00019, 77.71639, 'Meerut', 'Uttar Pradesh', 'L'],  // 20 office(s), spread 5.6 km
  '250002': [28.97508, 77.69794, 'Meerut', 'Uttar Pradesh', 'H'],
  '250003': [28.9886, 77.718, 'Meerut', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 1.2 km
  '250005': [28.97372, 77.64111, 'Meerut', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '250103': [28.93016, 77.64501, 'Meerut', 'Uttar Pradesh', 'H'],
  '250104': [29.00019, 77.71639, 'Meerut', 'Uttar Pradesh', 'L'],  // 9 office(s), spread 6.0 km
  '250205': [28.9105, 77.60169, 'Meerut', 'Uttar Pradesh', 'M'],  // 5 office(s), spread 6.0 km
  '250404': [29.00019, 77.71639, 'Meerut', 'Uttar Pradesh', 'L'],  // 11 office(s), spread 9.4 km
  '250501': [28.96469, 77.56142, 'Meerut', 'Uttar Pradesh', 'M'],  // 12 office(s), spread 7.1 km
  '250502': [29.0325, 77.52602, 'Meerut', 'Uttar Pradesh', 'M'],  // 14 office(s), spread 7.3 km
  '250617': [29.00019, 77.71639, 'Meerut', 'Uttar Pradesh', 'L'],  // 14 office(s), spread 8.4 km
  '250626': [29.00019, 77.71639, 'Meerut', 'Uttar Pradesh', 'L'],  // 7 office(s), spread 5.9 km

  // ---- New Delhi ----
  '110001': [28.62378, 77.21086, 'New Delhi', 'Delhi', 'H'],
  '110004': [28.62108, 77.19614, 'New Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110010': [28.5845, 77.13081, 'New Delhi', 'Delhi', 'H'],
  '110011': [28.61086, 77.21486, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.2 km
  '110021': [28.58078, 77.17272, 'New Delhi', 'Delhi', 'H'],
  '110022': [28.56222, 77.17243, 'New Delhi', 'Delhi', 'H'],
  '110023': [28.57548, 77.19965, 'New Delhi', 'Delhi', 'H'],
  '110028': [28.6305, 77.13492, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.4 km
  '110037': [28.54, 77.12, 'New Delhi', 'Delhi', 'H'],
  '110038': [28.52, 77.09, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 1.1 km
  '110046': [28.61106, 77.10292, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.6 km
  '110057': [28.55789, 77.15575, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 1.2 km
  '110066': [28.56531, 77.17975, 'New Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.6 km
  '110067': [28.55075, 77.17928, 'New Delhi', 'Delhi', 'H'],
  '110069': [28.62258, 77.21272, 'New Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110070': [28.52, 77.15, 'New Delhi', 'Delhi', 'H'],
  '110102': [28.63143, 77.20571, 'New Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- Noida ----
  '201008': [28.53552, 77.39103, 'Noida', 'Uttar Pradesh', 'L'],  // 3 office(s), spread 1.2 km
  '201301': [28.5792, 77.32424, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201302': [28.5787, 77.3134, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201303': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 2 office(s), spread 235.6 km
  '201304': [28.5337, 77.38513, 'Noida', 'Uttar Pradesh', 'M'],  // 4 office(s), spread 5.2 km
  '201305': [28.53921, 77.40637, 'Noida', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 1.0 km
  '201306': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 3 office(s), spread 2.6 km
  '201307': [28.58493, 77.38699, 'Noida', 'Uttar Pradesh', 'M'],  // 2 office(s), spread 3.5 km
  '201309': [28.6248, 77.40299, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201310': [28.5015, 77.52325, 'Noida', 'Uttar Pradesh', 'M'],  // 3 office(s), spread 5.4 km
  '201311': [28.53552, 77.39103, 'Noida', 'Uttar Pradesh', 'L'],  // 3 office(s), spread 13.8 km
  '201312': [28.45221, 77.52516, 'Noida', 'Uttar Pradesh', 'L'],  // 2 office(s), spread 19.7 km
  '201313': [28.54717, 77.33437, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201314': [28.53988, 77.56848, 'Noida', 'Uttar Pradesh', 'L'],  // 9 office(s), spread 19.2 km
  '201315': [28.44606, 77.5098, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201316': [28.59573, 77.4023, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201317': [28.52291, 77.35482, 'Noida', 'Uttar Pradesh', 'M'],  // 1 office(s), spread 0.0 km
  '201318': [28.66811, 77.42847, 'Noida', 'Uttar Pradesh', 'L'],  // 1 office(s), spread 0.0 km
  '203135': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 6 office(s), spread 7.5 km
  '203141': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 13 office(s), spread 7.7 km
  '203155': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 8 office(s), spread 7.1 km
  '203201': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 4 office(s), spread 6.9 km
  '203202': [28.40108, 77.65719, 'Noida', 'Uttar Pradesh', 'H'],
  '203203': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 12 office(s), spread 10.5 km
  '203207': [28.58246, 77.53212, 'Noida', 'Uttar Pradesh', 'M'],  // 7 office(s), spread 7.2 km
  '203209': [28.53083, 77.45992, 'Noida', 'Uttar Pradesh', 'L'],  // 5 office(s), spread 6.4 km

  // ---- North Delhi ----
  '110006': [28.65647, 77.22472, 'North Delhi', 'Delhi', 'H'],
  '110007': [28.6785, 77.20732, 'North Delhi', 'Delhi', 'H'],
  '110009': [28.69844, 77.20211, 'North Delhi', 'Delhi', 'H'],
  '110033': [28.72714, 77.17497, 'North Delhi', 'Delhi', 'H'],
  '110036': [28.79781, 77.13, 'North Delhi', 'Delhi', 'H'],
  '110039': [28.79969, 77.03806, 'North Delhi', 'Delhi', 'H'],
  '110040': [28.85081, 77.08806, 'North Delhi', 'Delhi', 'H'],
  '110042': [28.74411, 77.145, 'North Delhi', 'Delhi', 'H'],
  '110052': [28.67975, 77.17214, 'North Delhi', 'Delhi', 'H'],
  '110082': [28.77217, 77.119, 'North Delhi', 'Delhi', 'H'],
  '110088': [28.69336, 77.17139, 'North Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.0 km
  '110106': [28.66229, 77.23555, 'North Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- North East Delhi ----
  '110053': [28.69225, 77.27056, 'North East Delhi', 'Delhi', 'H'],
  '110090': [28.69225, 77.30422, 'North East Delhi', 'Delhi', 'L'],  // 3 office(s), spread 2.5 km
  '110093': [28.70219, 77.30501, 'North East Delhi', 'Delhi', 'H'],
  '110094': [28.69225, 77.30422, 'North East Delhi', 'Delhi', 'L'],  // 3 office(s), spread 2.4 km

  // ---- North West Delhi ----
  '110034': [28.68875, 77.13211, 'North West Delhi', 'Delhi', 'H'],
  '110035': [28.69211, 77.15786, 'North West Delhi', 'Delhi', 'H'],
  '110056': [28.68272, 77.11111, 'North West Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110081': [28.73492, 77.00556, 'North West Delhi', 'Delhi', 'H'],
  '110083': [28.69367, 77.09, 'North West Delhi', 'Delhi', 'H'],
  '110085': [28.70775, 77.132, 'North West Delhi', 'Delhi', 'H'],
  '110086': [28.70161, 77.07972, 'North West Delhi', 'Delhi', 'H'],
  '110089': [28.73481, 77.1325, 'North West Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110099': [28.7206, 77.08091, 'North West Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110110': [28.71575, 77.11, 'North West Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- Nuh ----
  '122105': [28.33089, 76.78358, 'Nuh', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122108': [27.9204, 76.98447, 'Nuh', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '122508': [28.42159, 76.91426, 'Nuh', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km

  // ---- Palwal ----
  '121102': [28.19444, 77.27712, 'Palwal', 'Haryana', 'L'],  // 12 office(s), spread 13.3 km
  '121103': [28.07181, 77.20934, 'Palwal', 'Haryana', 'L'],  // 9 office(s), spread 16.9 km
  '121105': [28.03595, 77.3465, 'Palwal', 'Haryana', 'L'],  // 7 office(s), spread 12.6 km
  '121106': [27.91788, 77.32383, 'Palwal', 'Haryana', 'M'],  // 6 office(s), spread 7.5 km
  '121107': [27.96903, 77.49292, 'Palwal', 'Haryana', 'L'],  // 5 office(s), spread 9.2 km

  // ---- Rewari ----
  '122502': [28.29298, 76.69725, 'Rewari', 'Haryana', 'H'],
  '123101': [28.209, 76.88411, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '123106': [28.23067, 76.80025, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '123110': [28.23356, 77.80328, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '123301': [28.35719, 76.5355, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '123302': [28.40022, 76.48392, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '123401': [28.20272, 76.61695, 'Rewari', 'Haryana', 'L'],  // 2 office(s), spread 51.9 km
  '123412': [28.20172, 76.59558, 'Rewari', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km

  // ---- Rohtak ----
  '124001': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 9 office(s), spread 4.0 km
  '124010': [28.73584, 76.74628, 'Rohtak', 'Haryana', 'L'],  // 7 office(s), spread 23.8 km
  '124021': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 7 office(s), spread 3.2 km
  '124022': [28.67159, 76.74809, 'Rohtak', 'Haryana', 'L'],  // 2 office(s), spread 0.0 km
  '124113': [28.60559, 76.62003, 'Rohtak', 'Haryana', 'L'],  // 3 office(s), spread 0.0 km
  '124303': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 7 office(s), spread 0.0 km
  '124401': [28.72537, 76.56269, 'Rohtak', 'Haryana', 'L'],  // 10 office(s), spread 24.9 km
  '124404': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 2 office(s), spread 0.0 km
  '124411': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 3 office(s), spread 0.0 km
  '124412': [28.60559, 76.62003, 'Rohtak', 'Haryana', 'L'],  // 3 office(s), spread 0.0 km
  '124501': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 14 office(s), spread 9.2 km
  '124513': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '124515': [28.68118, 76.51051, 'Rohtak', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km

  // ---- Shahdara ----
  '110031': [28.66061, 77.26642, 'Shahdara', 'Delhi', 'H'],
  '110032': [28.67742, 77.29908, 'Shahdara', 'Delhi', 'H'],
  '110095': [28.68254, 77.31315, 'Shahdara', 'Delhi', 'H'],
  '110151': [28.64573, 77.29977, 'Shahdara', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km
  '110195': [28.67396, 77.3197, 'Shahdara', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- Sonipat ----
  '131001': [29.01, 76.96, 'Sonipat', 'Haryana', 'H'],
  '131021': [28.96, 77.08, 'Sonipat', 'Haryana', 'H'],
  '131022': [28.99269, 77.01797, 'Sonipat', 'Haryana', 'M'],  // 1 office(s), spread 0.0 km
  '131023': [29.05, 76.91, 'Sonipat', 'Haryana', 'L'],  // 3 office(s), spread 0.0 km
  '131024': [29.06, 76.9, 'Sonipat', 'Haryana', 'H'],
  '131027': [29.03, 77.07, 'Sonipat', 'Haryana', 'H'],
  '131028': [29.05, 76.91, 'Sonipat', 'Haryana', 'L'],  // 3 office(s), spread 0.0 km
  '131029': [28.98, 77.1, 'Sonipat', 'Haryana', 'L'],  // 4 office(s), spread 0.0 km
  '131030': [29.05, 76.91, 'Sonipat', 'Haryana', 'L'],  // 1 office(s), spread 0.0 km
  '131039': [29.02, 77.06, 'Sonipat', 'Haryana', 'H'],
  '131101': [29.13, 77.01, 'Sonipat', 'Haryana', 'H'],
  '131102': [28.98, 77.1, 'Sonipat', 'Haryana', 'L'],  // 6 office(s), spread 20.9 km
  '131103': [29.05, 76.91, 'Sonipat', 'Haryana', 'L'],  // 5 office(s), spread 0.0 km
  '131304': [29.14, 77.04, 'Sonipat', 'Haryana', 'H'],
  '131402': [28.87, 76.91, 'Sonipat', 'Haryana', 'H'],
  '131403': [28.95, 76.93, 'Sonipat', 'Haryana', 'L'],  // 5 office(s), spread 16.7 km
  '131408': [28.98, 76.81, 'Sonipat', 'Haryana', 'H'],
  '131409': [29.05, 76.91, 'Sonipat', 'Haryana', 'L'],  // 4 office(s), spread 0.0 km

  // ---- South Delhi ----
  '110016': [28.54286, 77.19603, 'South Delhi', 'Delhi', 'H'],
  '110017': [28.52298, 77.21452, 'South Delhi', 'Delhi', 'H'],
  '110029': [28.56642, 77.19987, 'South Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.7 km
  '110030': [28.51761, 77.17936, 'South Delhi', 'Delhi', 'H'],
  '110047': [28.4759, 77.13153, 'South Delhi', 'Delhi', 'H'],
  '110062': [28.52011, 77.23975, 'South Delhi', 'Delhi', 'H'],
  '110068': [28.50122, 77.20031, 'South Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.0 km
  '110074': [28.50731, 77.18456, 'South Delhi', 'Delhi', 'H'],
  '110076': [28.53, 77.3, 'South Delhi', 'Delhi', 'H'],
  '110080': [28.51053, 77.24242, 'South Delhi', 'Delhi', 'H'],
  '110124': [28.56791, 77.2414, 'South Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- South East Delhi ----
  '110003': [28.58725, 77.23008, 'South East Delhi', 'Delhi', 'H'],
  '110013': [28.59122, 77.24233, 'South East Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.9 km
  '110014': [28.58294, 77.25203, 'South East Delhi', 'Delhi', 'H'],
  '110019': [28.54031, 77.24867, 'South East Delhi', 'Delhi', 'H'],
  '110020': [28.55211, 77.26867, 'South East Delhi', 'Delhi', 'H'],
  '110024': [28.57406, 77.24231, 'South East Delhi', 'Delhi', 'H'],
  '110025': [28.56136, 77.27958, 'South East Delhi', 'Delhi', 'H'],
  '110044': [28.5042, 77.3022, 'South East Delhi', 'Delhi', 'H'],
  '110048': [28.54047, 77.23467, 'South East Delhi', 'Delhi', 'H'],
  '110049': [28.55786, 77.21319, 'South East Delhi', 'Delhi', 'H'],
  '110065': [28.56469, 77.25558, 'South East Delhi', 'Delhi', 'H'],
  '110119': [28.5428, 77.25751, 'South East Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- South West Delhi ----
  '110045': [28.59718, 77.09078, 'South West Delhi', 'Delhi', 'H'],
  '110061': [28.53285, 77.05162, 'South West Delhi', 'Delhi', 'M'],  // 2 office(s), spread 0.8 km
  '110071': [28.54619, 76.99019, 'South West Delhi', 'Delhi', 'H'],
  '110072': [28.64019, 77.16597, 'South West Delhi', 'Delhi', 'L'],  // 2 office(s), spread 98.0 km
  '110073': [28.57094, 76.90769, 'South West Delhi', 'Delhi', 'H'],
  '110075': [28.60686, 77.04153, 'South West Delhi', 'Delhi', 'H'],
  '110077': [28.57153, 77.073, 'South West Delhi', 'Delhi', 'H'],
  '110078': [28.61022, 77.03767, 'South West Delhi', 'Delhi', 'M'],  // 2 office(s), spread 2.0 km
  '110097': [28.52888, 77.08655, 'South West Delhi', 'Delhi', 'M'],  // 1 office(s), spread 0.0 km

  // ---- West Delhi ----
  '110008': [28.64722, 77.16975, 'West Delhi', 'Delhi', 'H'],
  '110012': [28.64019, 77.16597, 'West Delhi', 'Delhi', 'L'],  // 3 office(s), spread 1.9 km
  '110015': [28.65414, 77.13564, 'West Delhi', 'Delhi', 'H'],
  '110018': [28.64636, 77.09906, 'West Delhi', 'Delhi', 'H'],
  '110026': [28.66786, 77.14344, 'West Delhi', 'Delhi', 'H'],
  '110027': [28.64269, 77.12322, 'West Delhi', 'Delhi', 'H'],
  '110041': [28.66683, 77.049, 'West Delhi', 'Delhi', 'H'],
  '110043': [28.6072, 76.98457, 'West Delhi', 'Delhi', 'M'],  // 13 office(s), spread 6.0 km
  '110058': [28.63006, 77.09121, 'West Delhi', 'Delhi', 'H'],
  '110059': [28.6215, 77.04153, 'West Delhi', 'Delhi', 'H'],
  '110063': [28.66871, 77.10291, 'West Delhi', 'Delhi', 'H'],
  '110064': [28.62486, 77.11087, 'West Delhi', 'Delhi', 'H'],
  '110087': [28.67975, 77.09269, 'West Delhi', 'Delhi', 'H'],
};

export default NCR_PINCODES;
